export const capitalize = (
  str: string,
  options?: {
    allWords?: boolean
  }
) => {
  if (options?.allWords) {
    return str
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ")
  }

  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}
